import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import TextField from './TextField';

const FullNameTextField = (props) => {
    const {
        data,
        label,
        record,
    } = props;

    const value = data || record;

    if (utils.isEmpty(value)) {
        return null;
    }

    function showFullName(item) {
        const {
            first_name,
            last_name,
        } = item;

        return utils.fullName(first_name, last_name);
    }

    return <TextField
        label={ label }
        value={ showFullName(value) }
    />;
};

FullNameTextField.propTypes = {
    data: PropTypes.shape({
        first_name: PropTypes.string,
        firstname: PropTypes.string,
        last_name: PropTypes.string,
        lastname: PropTypes.string,
    }),
    label: PropTypes.string,
    record: PropTypes.object,
};

export default FullNameTextField;



// WEBPACK FOOTER //
// ./src/components/show/FullNameTextField.js